import { Trans } from '@lingui/react'
import {
  Modal,
  ModalNavigation,
} from '@twistopayments/design-system/components/atoms/modal'
import { useRouter } from 'next/router'

import type { FlowType } from '@twisto/api-graphql'
import { useCancelFlow } from '@twisto/flow-views/components'

import { ConsentCollectionContent } from './consent-collection-content'
import { IncomeVerificationContent } from './income-verification-content'
import { OnboardingContent } from './onboarding-content'
import { PayInNContent } from './pay-in-n-content'

export type OnModalClose = (options?: { skipAnalytics: boolean }) => void

type Props = {
  open: boolean
  hasPurchaseContext: boolean
  flowType?: FlowType
  onClose: OnModalClose
  currentStep: string
}

export const FLOW_LEAVE_MODAL_TITLE = 'leave-modal-title-id'
export const FlowLeaveConfirmModal = ({
  open,
  hasPurchaseContext,
  onClose,
  flowType,
  currentStep,
}: Props) => {
  let modalContent
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const cancelFlow = useCancelFlow(sessionId)

  switch (flowType) {
    case 'INCOME_VERIFICATION':
      modalContent = <IncomeVerificationContent onClose={onClose} />
      break
    case 'ONBOARDING':
      if (hasPurchaseContext) {
        modalContent = <PayInNContent onClose={onClose} />

        break
      }

      modalContent = (
        <OnboardingContent
          isOpened={open}
          stepName={currentStep}
          onClose={onClose}
        />
      )
      break
    case 'CONSENT_COLLECTION':
      modalContent = <ConsentCollectionContent onClose={onClose} />
      break
    case 'PAY_IN_N':
      modalContent = <PayInNContent onClose={onClose} />
      break
    default:
      if (open) {
        cancelFlow()
      }

      return null
  }

  return (
    <Modal
      noPadding
      aria-labelledby={FLOW_LEAVE_MODAL_TITLE}
      opened={open}
      variant="centered"
      onClickOutside={onClose}
    >
      <ModalNavigation
        modalCloser={{
          onClick: onClose,
        }}
        title={<Trans id="flow.leaveConfirmModal.modalNavigation.title" />}
        titleId={FLOW_LEAVE_MODAL_TITLE}
      />
      {modalContent}
    </Modal>
  )
}
